export * from './information-section.module';
